import React from "react";
import { Fragment } from "react";
import { Link, useNavigate } from "react-router-dom";
import styles from "./empty.module.css";

const Empty = () => {
  const navigate = useNavigate();
  const routhHandler = () => {
    navigate("./add-car");
  };

  return (
    <Fragment>
      {/* هشدار کاربر گرامی */}
      <div className="alert alert-warning border-0 shadow-sm rounded-3 p-4 mb-4" role="alert" dir="rtl" style={{ fontFamily: "Vazir, sans-serif", lineHeight: "1.9" }}>
        <div className="d-flex align-items-center mb-2">
          <i className="bi bi-exclamation-triangle-fill fs-4 me-2 text-warning"></i>
          <h5 className="fw-bold mb-0">کاربر گرامی</h5>
        </div>
        <p className="mb-2">
          پس از <strong>ثبت‌نام</strong>، به مدت <strong>۳۰ روز</strong> می‌توانید از تمامی امکانات برنامه استفاده نمایید و از صحت عملکرد آن در دستگاه خود اطمینان حاصل کنید.
        </p>
        <p className="mb-3">
          پس از پایان این مدت، با <strong>خرید اشتراک سالانه</strong> همچنان از تمام قابلیت‌ها بهره‌مند خواهید شد. در غیر این صورت، برنامه به‌صورت <strong>محدود</strong> در دسترس شما خواهد بود.
        </p>
        <Link to="/subscription" className="btn btn-outline-warning btn-sm fw-bold">
          خرید اشتراک سالانه
        </Link>
      </div>

      {/* دکمه خودروی جدید - عریض و با فاصله از پایین */}
      <div className="d-flex justify-content-center align-items-center bg-light px-3 mb-5" dir="rtl">
        <div className="w-100">
          <button
            type="button"
            className="btn btn-info btn-lg text-white w-100 py-3"
            onClick={routhHandler}
          >
            خودروی جدید
          </button>
        </div>
      </div>

      {/* بخش امکانات رایگان - با EMOJI */}
      <div className="card border-0 shadow-sm rounded-3 mb-4" dir="rtl">
        <div className="card-header bg-white border-0 pt-4 pb-0">
          <div className="d-flex align-items-center">
            <span className="fs-4 me-2">🎁</span>
            <h5 className="fw-bold mb-0 text-success">امکانات رایگان نسخه محدود</h5>
          </div>
        </div>
        <div className="card-body pb-4">
          <div className="list-group list-group-flush">
            <div className="list-group-item border-0 px-0 py-2 d-flex align-items-center">
              <span className="text-success me-2">✅</span>  {/* به جای bi bi-check-circle-fill */}
              <span>تعریف <strong className="text-info">یک خودرو</strong></span>
            </div>
            <div className="list-group-item border-0 px-0 py-2 d-flex align-items-center">
              <span className="text-success me-2">✅</span>
              <span>تعریف سرویس <strong className="text-info">تعویض روغن موتور</strong></span>
            </div>
            <div className="list-group-item border-0 px-0 py-2 d-flex align-items-center">
              <span className="text-success me-2">✅</span>
              <span>ثبت <strong className="text-info">سابقه</strong> سرویس</span>
            </div>
            <div className="list-group-item border-0 px-0 py-2 d-flex align-items-center">
              <span className="text-success me-2">✅</span>
              <span>نمایش <strong className="text-info">آخرین</strong> سابقه سرویس</span>
            </div>
          </div>
        </div>
        <div className="card-footer bg-white border-0 pb-4 pt-0">
          <div className="alert alert-light mb-0 py-2 rounded-3">
            <span className="text-muted me-1">ℹ️</span>
            <small className="text-muted">برای دسترسی به امکانات بیشتر، اشتراک خود را فعال کنید.</small>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Empty;
